export default __webpack_public_path__ + "static/isoqar-f2942b71ffd1cc55b487d1f5208b0d13.svg";